import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "slashWhenNull" })
export class SlashWhenNullPipe implements PipeTransform {
  transform(value: string | number): string {
    return value ? value.toString() : "-";
  }
}
